// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"6e68e3da","222":"c693822d","377":"60a8d79f","453":"b8d2a226","631":"bb93a4bd","662":"c0061471","672":"babe7589","688":"774398c3","707":"55381f39","748":"a7bbceef","858":"31c960f5"}[chunkId] + ".chunk.js";
};